// import React from "react";
// import { NavLink } from "react-router-dom";

// const DraftPopup = ({ setDelete, id, isAdaptive, autoEvaluate }) => {
//   return (
//     <>
//       <div className=" p-3 main_card_popup_box ">
//         {/* <button className="main_card_popup_button">Edit</button> */}

//         <NavLink to={`/DaftQLists`} state={{ assessmentId: id, isAdaptive: isAdaptive, autoEvaluate: autoEvaluate }} className="link">
//           <button
//             className="main_card_popup_button"
//             onClick={(e) => setDelete(true)}
//           >
//             Edit
//           </button>
//         </NavLink>
//         <button
//           className="main_card_popup_button"
//           onClick={(e) => setDelete(true)}
//         >
//           Delete
//         </button>
//       </div>
//     </>
//   );
// };

// export default DraftPopup;

import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const DraftPopup = ({ setDelete, id, isAdaptive, autoEvaluate }) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 80,
      }}
    >
      <Stack spacing={2}>
        <NavLink
          to={`/DaftQLists`}
          state={{
            assessmentId: id,
            isAdaptive: isAdaptive,
            autoEvaluate: autoEvaluate,
          }}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="outlined"
            color="warning"
            fullWidth
            startIcon={<EditIcon />}
            onClick={() => setDelete(true)}
            sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          >
            Edit
          </Button>
        </NavLink>

        <Button
          variant="outlined"
          color="error"
          fullWidth
          startIcon={<DeleteIcon />}
          onClick={() => setDelete(true)}
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        >
          Delete
        </Button>
      </Stack>
    </Box>
  );
};

export default DraftPopup;
